const mortgageCalculator = {
  description: '',
  rightText: '',
  video: '',
};

export default mortgageCalculator;
